import { app } from "@/modules/app";

app.addRoutes([
    {
        name: 'front',
        parent: 'public',
        path: '',
        components: {
            default: () => import("@/pages/front.vue"),
            top: () => import("@/components/Offer/BannerOffers.vue"),
        },
        meta: {
            keepAlive: true
        }
    },
])

